import { http } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';
import { parseWithSchema } from '@/shared/api/parseResponse';
import { adminOverviewSchema, type AdminOverview } from '../types/overview.schema';

export const overviewService = {
  async fetch(): Promise<AdminOverview> {
    const { data } = await http.get(endpoints.admin.overview);
    return parseWithSchema(adminOverviewSchema, data, 'overview.fetch');
  },
};
